import * as React from "react";
import {EcommProductPrice} from "../Price/Price";
import {Button} from "../../elements/Button/Button";
import Image from "../../elements/Image/Image";
import {Headings} from "../../elements/Headings/Headings";
import {Swatches} from "../Swatches/Swatches";

import './ProductCard.scss';

export const EcommProductCard = ({ product, swatches = [], show_add = false, show_price_inline = false}) => {
    return (
        <div className={'product-card'}>
            <div className={'product-card__content'}>
                {product.image && <Image imageUrl={product.image}/> }
                
                <div className={'product-card__product-title'}>
                    <Headings text={product.title} type={'h4'}/>
                </div>

                <Swatches swatches={swatches}/>

                {!show_price_inline &&
                    <EcommProductPrice price={product.price} compare_at_price={product.compare_at_price}/>
                }

                <div className={'button-full'}>
                    {show_add && show_price_inline
                        ? <Button label={`$${13.95} | Add to cart`} onClick={undefined}/>
                        : <Button label={"Add to cart"} onClick={undefined}/>
                    }
                </div>
            </div>
        </div>
    );
};
